import React, { useRef, useState } from "react";

/**
 * @param {String} shortProjectName - The short name of the project. 
 * @param {String} projectName - The name of the project. 
 * @param {String} projectNameColor - The color of the short project name. 
 * @param {String} image - The image of the project. 
 * @param {String} description - The description of the project.
 * @param {String} projectLink - The link of the project folder. 
 * @param {String} readingsLink - The link of the project readings. 
 */ 

function Project(props) {
  const imageRef = useRef(null); 
  const [collapsed, setCollapsed] = useState(true);

  const toggleDescription = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="project">
      <h1
        className="section-header"
        style={{ color: props.projectNameColor }}
      >
        {props.shortProjectName}
      </h1>

      <h2 className="sub-header">
        {props.projectName}
      </h2>

      <div className="project-content">
        <a href={props.link} target="_blank" rel="noopener noreferrer">
          <img
            src={props.image}
            alt={props.projectName}
            className="content-img"
          />
        </a>

        <div className="project-text-container">
          <p
            className={`section-text ${collapsed ? "" : "expanded"}`}
            ref={imageRef}
          >
            {props.description}
          </p>

          <div className="buttons-and-links">
            <button className="show-more-button" onClick={toggleDescription}>
              {collapsed ? "Show More" : "Show Less"}
            </button>

            <div className="project-links">
              <a
                className="project-link"
                href={props.readingsLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Project Readings
              </a>
              <a
                className="project-link"
                href={props.projectLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Project Folder
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
